import React from 'react';
import { RouteChildrenProps } from 'react-router';
import { DishFirstModal } from './components/Segments/DishFirstModal';
import { DishFirstExploreCart } from './DishFirstExploreCart';
import { DishFirstExploreContents } from './DishFirstExploreContents';

export class DishFirstExplore extends React.Component<RouteChildrenProps> {
  shouldComponentUpdate(nextProps: RouteChildrenProps) {
    // Only update when location changes.
    return (
      this.props.location.pathname !== nextProps.location.pathname ||
      this.props.location.search !== nextProps.location.search
    );
  }

  render() {
    return (
      <>
        <DishFirstExploreCart routeChildrenProps={this.props} />
        <DishFirstExploreContents />
        <DishFirstModal />
      </>
    );
  }
}

export default DishFirstExplore;
